module.exports = __webpack_public_path__ + "img/gbz9.36471efe.png";